<nav role="navigation" class="mt-4 flex items-center space-x-6 lg:space-x-8 justify-end">
  <div class="flex w-[100px] items-center justify-center text-sm font-medium">

    Page {{ currentPage }} of {{  totalPages }}

  </div>
  <div class="flex items-center space-x-2">
    <button
      (click)="changePage(1)"
      [disabled]="isFirstPage"
      class="items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background border border-base-300 hover:bg-gray-200 hover:text-accent-foreground hidden h-8 px-2 lg:flex">
      <span class="sr-only">Go to first page</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4">
        <polyline points="11 17 6 12 11 7"></polyline>
        <polyline points="18 17 13 12 18 7"></polyline>
      </svg>
      <span>First</span>
    </button>
    <button
      (click)="changePage(currentPage - 1)"
      [disabled]="isFirstPage"
      class="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background border border-base-300 hover:bg-gray-200 hover:text-accent-foreground h-8 px-2">
      <span class="sr-only">Go to previous page</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4">
        <polyline points="15 18 9 12 15 6"></polyline>
      </svg>
      <span>Previous</span>
    </button>
    <button
      (click)="changePage(currentPage + 1)"
      [disabled]="isLastPage"
      class="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background border border-base-300 hover:bg-gray-200 hover:text-accent-foreground h-8 px-2">
      <span class="sr-only">Go to next page</span>
      <span>Next</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
    </button>
    <button
      (click)="changePage(totalPages)"
      [disabled]="isLastPage"
      class="items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background border border-base-300 hover:bg-gray-200 hover:text-accent-foreground hidden h-8 px-2 lg:flex">
      <span class="sr-only">Go to last page</span>
      <span>Last</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4">
        <polyline points="13 17 18 12 13 7"></polyline>
        <polyline points="6 17 11 12 6 7"></polyline>
      </svg>
    </button>
  </div>
</nav>
